<template>
  <div>worker
    <v-btn @click="handleClick">test</v-btn>
    <v-btn @click="handleClick2">34</v-btn>
    <v-btn @click="handleClick3">handleClick3</v-btn>
    <v-btn>dummy</v-btn>
  </div>
</template>

<script>
import * as R from 'ramda'
import myWorker from '@/worker'
const consola = require('consola')
export default {
  name: 'workerview',
  methods: {
    async handleClick3 () {
      // var arr = [1.5]
      var arr = [1.5, 1.5, 1.5, 1.5, 1, 1]
      var aa = await myWorker.getCombination({arr, target: 5.5, option: 'over'}) // おかしい
      window.alert(aa)
    },
    async handleClick2 () {
      var arr = [1.5,1.5,1,1.5,1.5,1.5,1.5,1,1.5,1.5,1,1.5,1.5,1,1.5,1.5,1.5,1.5,1.5,1,1,1.5,1.5,1.5,1.5,1.5,1.5,1.5,1,1.5,1.5,1,1,1.5,1.5,1.5,1.5,1,1.5,1.5,1.5,1.5]
      // var arr = [1.5,1.5,1,1.5,1.5,1.5,1.5,1,1.5,1.5,1,1.5,1.5,1,1.5,1.5,1.5,1.5,1.5,1,1,1.5,1.5]
      // window.alert(R.sum(arr))
      // var aa = await myWorker.getCombination({arr, target: 56, option: 'over'}) // おかしい
      var aa = await myWorker.getCombination({arr, target: 34, option: 'over'}) // おかしい
      // window.alert(aa)
      consola.log(aa)
      
      consola.log(R.sum(JSON.parse(aa).result))
    },
    async handleClick () {
      // var arr = [1,1,1,1,1,1,1,1,1,1,2,1,1,2,2,1,1,3,0.5,0.5,1,1,0.5,1,1,2,1]
      // var arr = [10,2,1,1,2,2,1,1,3,0.5,0.5,1,1,0.5,1,1,2,1]
      // var arr = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 6, 1, 1, 1, 1, 2, 1, 3, 1, 1, 1, 1, 1, 1, 3, 2, 1, 1, 2, 1, 1, 1, 1, 1, 2, 2, 2, 1, 3, 3, 1, 3, 2, 1, 1, 1.5, 1.5, 1.5]
      var arr = [1, 1, 1, 2, 1, 1, 1, 1]
      // var arr = [10, 2, 6, 2, 3,10,10, 3, 2, 2, 2, 2, 2, 3, 3, 1, 3, 2, 1, 1, 1.5, 1.5, 1.5]
      // myWorker.getCombination({arr, target: 6})
      //   .then(reply3 => alert(reply3))

      // var aa = await myWorker.getCombination({arr, target: 2.5})
      var aa = await myWorker.getCombination({arr, target: 2.5, option: 'over'}) // おかしい
      // var aa = await myWorker.getCombination({arr, target: 5.5, option: 'over'}) // おかしい
      // var aa = await myWorker.getCombination({arr, target: 5.2, option: 'over'})
      // var aa = await myWorker.getCombination({arr, target: 4.5})
      // var aa = await myWorker.getCombination({arr, target: 19})
      window.alert(aa)
      
      // console.log(R.countBy(R.identity)(arr))
    }
  },
  mounted () {
    
  }
}
</script>

<style>

</style>
